export function handleDateChangeRaw(e): void {
	if (e) {
		e.preventDefault();
	}
}
